import { IonLoading } from "@ionic/react";

export const Loading: React.FC = () => (
  <IonLoading isOpen message={"Loading Reel..."} duration={5000} />
);
